import { Component, Input, OnInit, OnDestroy, SecurityContext } from "@angular/core";
import { SubSink } from "subsink";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { forkJoin, Observable, Subject, Subscriber } from "rxjs";
import { takeUntil, switchMap, mergeMap } from "rxjs/operators";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import { SharedDataService } from "../../../shared/sharedData.service";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { OnboardingService } from "../../../shared/services/onboarding.service";
import { RemotesQueryService } from "../../../shared/services/remotesquery.service";
import { cloneDeep } from "lodash";
import { NbcModalConfirmation } from "../../../shared/component/confirmation/nbc-modal-confirmation.component";
import { EditPositionRequestComponent } from "../request/list/editPositionRequest.component";
import { ContactService } from "../../../shared/services/contact.service";
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: "onboardingrequestlayout",
    templateUrl: "./request-layout-component.html",
    standalone: false,
})
export class OnboardingLayoutRequestComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBus: EventBusService,
        private onboardingService: OnboardingService,
        private _sharedDataService: SharedDataService,
        private _talentQueryService: RemotesQueryService,
        public _modalService: BsModalService,
        private _contactService: ContactService,
        private log: NbcLoggerService,
        private sanitizer: DomSanitizer
    ) {}

    hrCounts: any | undefined;
    componentDestroyed$: Subject<boolean> = new Subject();
    private subs = new SubSink();
    onboardingMasterData: any[] = [];
    proxyList: any;
    employeeTypes: any;
    requestStatus: any;
    companyCodes: any;
    contactTypes: any;
    registrationStatus: any;
    selectedRequestStatus: any = "";
    selectedRegistrationStatus: any = "";
    selectedEmployeeType: any = "";
    selectedContactType: any = "";
    selectedBusinessUnit: any;
    searchTextboxEnable: any = true;
    goButtonEnable: any = true;
    contactObservable$: Observable<any[]> | undefined;
    contactSearchTerm = "";
    hasContactSelected = false;
    
    selectSearchCriteria: any = {
        optionValue: "0",
        optionDescription: "",
    };

    gridData: any = {
        items: [],
        query: "",
    };

    bsModalRef?: BsModalRef;

    queryContainer: any | undefined;
    childwindows = [];
  newWindow = null;  

    pageSizeList: any[] = [10, 25, 50, 100];

    searchCriteria: any = [
        { optionValue: "1", optionDescription: "Contact Name" },
    ];

    itemCount1 = 0;
    itemCount2 = 0;
    itemCount3 = 0;
    itemCount4 = 0;
    itemCount5 = 0;
    itemCount6 = 0;
    itemCount7 = 0;

    changeSearchCriteria(): void {
        if (
            this.selectSearchCriteria.optionValue &&
            this.selectSearchCriteria.optionValue != 0
        ) {
            this.queryContainer.query.searchTerm.id =
                this.selectSearchCriteria.optionValue;
            this.enableSearchButton();
        } else {
            this.queryContainer.query.searchTerm.description = "";
            this.disableSearchButton();
        }
    }

    disableSearchButton(): void {
        this.goButtonEnable = true;
        this.searchTextboxEnable = true;
        this.queryContainer.query.searchTerm.description = "";
    }

    enableSearchButton(): void {
        this.goButtonEnable = false;
        this.searchTextboxEnable = false;
        this.queryContainer.query.searchTerm.description = "";
    }

    onContactSearchTermSelect($searchTerm): void {
        this.queryContainer.query.searchTerm.description =
            $searchTerm?.item?.fullName;
        this.queryContainer.query.searchTerm.name = $searchTerm?.item?.id;
    }

    changeTypeaheadLoading($event) {}

    //onBlur() {
    //  if (!this.hasContactSelected) {
    //    this.contactSearchTerm = "";
    //  }
    //}

    contactTypeahead() {
        this.hasContactSelected = false;
        this.contactObservable$ = new Observable(
            (observer: Subscriber<string>) => {
                if (this.contactSearchTerm != "") {
                    observer.next(this.contactSearchTerm);
                }
            }
        ).pipe(
            takeUntil(this.componentDestroyed$),
            switchMap((token: string) => {
                this.queryContainer.query.searchTerm.description = token; //contact name fuzzy search
                return this._contactService.searchByName(
                    encodeURIComponent(token)
                );
            })
        );
    }

    changeRequestStatus() {
        if (this.selectedRequestStatus?.id) {
            this.queryContainer.query.requestStatusId =
                this.selectedRequestStatus.id;
        } else {
            this.queryContainer.query.requestStatusId = null;
        }
        this.queryContainer.query.currentPage = 1;
        this.search();
    }

    changeRegistrationStatus() {
        if (this.selectedRegistrationStatus?.description) {
            this.queryContainer.query.registrationStatus =
                this.selectedRegistrationStatus.description;
        } else {
            this.queryContainer.query.registrationStatus = null;
        }
        this.queryContainer.query.currentPage = 1;
        this.search();
    }

    changeEmployeeType() {
        if (this.selectedEmployeeType?.description) {
            this.queryContainer.query.employeeType =
                this.selectedEmployeeType.description;
        } else {
            this.queryContainer.query.employeeType = null;
        }
        this.queryContainer.query.currentPage = 1;
        this.search();
    }

    changeContactType() {
        if (this.selectedContactType?.description) {
            this.queryContainer.query.contactType =
                this.selectedContactType.description;
        } else {
            this.queryContainer.query.contactType = null;
        }
        this.queryContainer.query.currentPage = 1;
        this.search();
    }

    restartSearch(): void {
        this.queryContainer = {
            query: this._talentQueryService.getHrOnboardingRequestTabQuery(),
        };
        this.selectedRequestStatus = "";
        this.selectedEmployeeType = "";
        this.selectedContactType = "";
        this.selectedRegistrationStatus = "";
        this.search();
        this.goButtonEnable = true;
        this.searchTextboxEnable = true;
        this.contactSearchTerm = "";
        this.selectSearchCriteria = "";
    }

    sortColumn(column) {
        if (this.queryContainer.query.sortByColumn === column) {
            this.queryContainer.query.reverseSort =
                !this.queryContainer.query.reverseSort;
        } else {
            this.queryContainer.query.sortByColumn = column;
            this.queryContainer.query.reverseSort = false;
        }
        this.search();
    }

    searchPage(pageSize) {
        this.queryContainer.query.pageSize = pageSize;
        this.search();
    }

    requestStatusSearch(status) {
        this.queryContainer.query.requestStatusId = status;
        this.search();
    }

    search(): void {
        this.log.trace("OnboardingRequest -> Search() called");
        this.queryContainer.query.businessUnitId =
            this.selectedBusinessUnit?.id;
        const onboardingQuery = cloneDeep(this.queryContainer);
        this.onboardingService
            .search(onboardingQuery.query, "request")
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (data) => {
                    this.log.trace(
                        "OnboardingRequest -> Search(): Data received"
                    );

                    this.queryContainer.query.totalRecords =
                        data.reference.totalRecords;
                    this.gridData.items = data.reference.items;
                    this.gridData.query = this.queryContainer.query;

                    setTimeout(() => {
                        this._eventBus.emit(
                            new EmitEvent(
                                "onboard-request:search",
                                "buildOnboardingRequestGrid",
                                this.gridData
                            )
                        );
                    }, 300);
                },
              (err) => {
                this.log.showError(err);
                },
                () => {
                    this.log.trace("OnboardingRequest -> removing spinner");
                }
            );
    }

    getOnboardingCounts() {
        this.onboardingService
            .getTalentOnboardingCount(this.selectedBusinessUnit?.id)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (data) => {
                    this.log.trace(
                        "OnboardingHeader -> getHrCounts: data received"
                    );
                    this.itemCount1 = data.reference.positionRequestsSubmitted;
                    this.itemCount2 = data.reference.registrationsSubmitted;
                    this.itemCount3 = data.reference.registrationsApproved;
                    this.itemCount4 = data.reference.onboardingsInprogress;
                    this.itemCount5 = data.reference.requestsComplete;
                    this.itemCount6 = data.reference.registrationsRejected;
                    this.itemCount7 = data.reference.registrationsCancelled;
                },
                (err) => {
                    this.log.error(err);
                },
                () => {
                    this.log.trace("OnboardingHeader -> removing spinner");
                }
            );
    }

    getTalentPermission() {
        const userRoles = window.preload?.user?.userRoles || [];

        const sfModalView = _.find(userRoles, { description: "Payroll SU" })
            ? "talent_payroll"
            : _.find(userRoles, { description: "Talent SU" })
              ? "talent_su"
              : null;

        return sfModalView;
    }

    openHrOnboardingPositionModal(hrOnboardingItem) {
        //const positionRequestNo = hrOnboardingItem.requestNumber;
        const crewRegNo = hrOnboardingItem.registrationNo;
        //const drupalUrl = window.preload.uisettings.drupalModal;
      const sfViewName = this.getTalentPermission();
        let url = "";
        const modalSharedResource = {
            userSSO: "501307978",
            regNumber: crewRegNo,
          view: sfViewName,
            subtab: "registration",
            accessLevel: "Edit",
        };
        this.onboardingService
            .getSFModalURL(
                modalSharedResource,
                hrOnboardingItem?.businessUnitId
            )
            .subscribe({
                next: (result: any) => {
                    url = result.reference;
                    const settings =
                        "top=125,left=280,width=800,height=775,location=0,titlebar=0";

                    const newWindow = window.open(url, crewRegNo, settings);

                    for (let i = 0; i < this.childwindows.length; i++) {
                        if (
                            this.childwindows[i] &&
                            this.childwindows[i] == newWindow &&
                            this.childwindows[i].opened
                        ) {
                            this.childwindows.splice(i, 1);
                            this.childwindows[i].close();
                        }
                    }
                    this.childwindows[this.childwindows.length] = newWindow;
                    if (newWindow) {
                        newWindow.focus();
                    }
              },
              error: (err) => {
                this.log.error(err);
                this.log.showError(err.error.message);
              }
            });
        return false;
    }

    openEditPositionRequestModal(hrOnboardingItem) {
        const initialState: any = {
            self: this,
            hrOnboardingItem: hrOnboardingItem,
            companyCodes: this.companyCodes,
            proxyList: this.proxyList,
            modalTitle: hrOnboardingItem ? "Edit Onboarding Request" : "",
            isAdd: false,
        };
        const modalOptions = {
            animated: true,
            ignoreBackdropClick: true,
            initialState: initialState,
            keyboard: false,
            class: "edit-position-modal",
        };

        this.bsModalRef = this._modalService.show(
            EditPositionRequestComponent,
            modalOptions
        );

        this.bsModalRef.content.onSync.subscribe((result) => {
            this.search();
        });
    }

    openCancelRequestModal(registrationObject) {
        this.log.trace("Opening modal");
        const initialState: any = {
            self: this,
            modalTitle: "Warning",
            modalMessage:
                "Are you sure you want to Cancel? This will remove the request and user’s access to the Event Portal.",
            confirmText: "Confirm",
            cancelText: "Close",
            hideConfirm: false,
        };
        const modalOptions = {
            animated: true,
            initialState: initialState,
            keyboard: false,
        };
        this.bsModalRef = this._modalService.show(
            NbcModalConfirmation,
            modalOptions
        );
        this.bsModalRef.content.onAffirmation.subscribe((result) => {
            this.cancelRegistration(registrationObject);
        });
    }

    cancel(registrationObject): void {
        this.openCancelRequestModal(registrationObject);
    }

    cancelRegistration(registrationObject) {
        this.log.trace("OnboardingRequest -> cancel registration");

        this.subs.sink = this.onboardingService
            .cancelOnboardingRequests(registrationObject)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (data) => {
                    this.getOnboardingCounts();
                    this.search();
                },
                (err) => {
                    this.log.error("OnboardingRequest -> Cancel error:" + err);
                },
                () => {
                    this.log.trace(
                        "OnboardingRequest -> Cancel removing spinner"
                    );
                }
            );
    }

    updateDetails(registrationObjects: any) {
        this.update(registrationObjects);
    }

    updateI9VerifyDetails(registrationObjects: any) {

      this.log.trace("OnboardingRequest -> updateI9VerifyDetails called");
      const regData = _.cloneDeep(registrationObjects);

      this.subs.sink = this.onboardingService
        .updateI9VerifyReason(regData)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(
          (data) => {
            this.log.trace(
              "updateI9VerifyDetails -> Update getting updated HrCounts and Grid Data"
            );
            this.getOnboardingCounts();
            this.search();
          },
          (err) => {
            this.log.error("updateI9VerifyDetails -> Update error:" + err);
          },
          () => {
            this.log.trace(
              "updateI9VerifyDetails -> Update removing spinner"
            );
          }
        );

    }

    updateTafDetails(registrationObjects: any) {
        this.log.trace("OnboardingRequest -> updateTafDetails called");
        const regData = _.cloneDeep(registrationObjects);

        this.subs.sink = this.onboardingService
            .updateTafSubmittedFlag(regData)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (data) => {
                    this.getOnboardingCounts();
                    this.search();
                },
                (err) => {
                    this.log.error("updateTafSubmittedFlag -> Update error:" + err);
                }
            );
    }


    update(registrationObject): void {
        this.log.trace("OnboardingRequest -> Update called");
        const regData = _.cloneDeep(registrationObject);

        this.subs.sink = this.onboardingService
            .update(regData)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (data) => {
                    this.log.trace(
                        "OnboardingRequest -> Update getting updated HrCounts and Grid Data"
                    );
                    this.getOnboardingCounts();
                    this.search();
                },
                (err) => {
                    this.log.error("OnboardingRequest -> Update error:" + err);
                },
                () => {
                    this.log.trace(
                        "OnboardingRequest -> Update removing spinner"
                    );
                }
            );
    }

    getMasterData() {
        this.subs.sink = this.onboardingService
            .getOnboardingDashboardMasterData("request")
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe({
                next: (result) => {
                    this.onboardingMasterData = result.reference;
                    this.employeeTypes = result.reference.employeeTypes;
                    this.requestStatus = result.reference.onboardingStatus;
                    this.registrationStatus =
                        result.reference.registrationStatus;
                    this.companyCodes = result.reference.companyCodes;
                    this.contactTypes = result.reference.contactTypes; 
                },
                error: (err) => {
                    this.log.showError("Business Units failed to load");
                },
            });
    }

    getProxyList() {
      this.subs.sink = this.onboardingService.getOnboardingMasterData().subscribe({
        next: (result) => {
          this.proxyList = result.reference.proxy;
        },
        error: (err) => {
          this.log.showError("Business Units failed to load");
        },
      });
    }

    onBusinessUnitSelected(data: any) {
        this.selectedBusinessUnit = data; 
  }

  showContactSearchFlyout() {
    //this.contactFlyoverSubject.next(); 
    //this.contactFlyoverSubject.next(""); //TODO: Revisit
    this._sharedDataService.setFlyOverStatus("");
  
  }

    subscribeEventHandlers() {
        this.subs.sink = this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe((selectedBu) => this.onBusinessUnitSelected(selectedBu));

        this.subs.sink = this._eventBus.on("changeSortColumn", (dataSource) =>
            this.sortColumn(dataSource)
        );
        this.subs.sink = this._eventBus.on("updateDetails", (dataSource) =>
            this.updateDetails(dataSource)
        );
        this.subs.sink = this._eventBus.on("cancelReg", (DataSource) =>
            this.cancel(DataSource)
        );
        this.subs.sink = this._eventBus.on(
            "openHrOnboardingPositionModal",
            (hrOnboardingItem) =>
                this.openHrOnboardingPositionModal(hrOnboardingItem)
        );
        this.subs.sink = this._eventBus.on(
            "openEditPosReqModal",
            (hrOnboardingItem) =>
                this.openEditPositionRequestModal(hrOnboardingItem)
        );

        this.subs.sink = this._eventBus.on("updateI9VerifyDetails", (dataSource) => 
            this.updateI9VerifyDetails(dataSource)
        );

        this.subs.sink = this._eventBus.on("updateTafDetails", (dataSource) =>
            this.updateTafDetails(dataSource)
        );

    }

    ngOnInit() {
        this.subscribeEventHandlers();
        this.contactTypeahead();
        this.queryContainer = {
            query: this._talentQueryService.getHrOnboardingRequestTabQuery(),
        };
        this.gridData.query =
            this._talentQueryService.getHrOnboardingRequestTabQuery();
        this.getOnboardingCounts();
        this.getMasterData();
      this.search();
      this.getProxyList();
    }

    ngOnDestroy() {
        this.componentDestroyed$.next(true);
        this.componentDestroyed$.complete();
        this.subs.unsubscribe();
    }
}
